"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfiguration = void 0;
exports.withDefaults = withDefaults;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _colors = require("./colors");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultConfiguration = exports.defaultConfiguration = Object.freeze({
  activeFieldColor: _colors.COLORS.blue,
  buttonColor: _colors.COLORS.blue,
  buttonHoverColor: _colors.COLORS.buttonHover,
  buttonShape: 'pill',
  buttonTextColor: _colors.COLORS.white,
  dropdownSelectionColor: "".concat(_colors.COLORS.blue, "60"),
  labelPosition: 'outside',
  linkColor: _colors.COLORS.blue,
  primaryFont: 'Arial',
  primaryFontColor: _colors.COLORS.primaryTypography,
  secondaryFont: 'Arial'
});
function withOverrides(defaults, overrides) {
  var merged = _objectSpread({}, defaults);
  for (var key in merged) {
    if (overrides[key] != null) {
      merged[key] = overrides[key];
    }
  }
  return merged;
}
function withDefaults(configuration) {
  return withOverrides(defaultConfiguration, configuration);
}